<script>
import { get } from 'lodash'
import RootHeader from './headers'
import Sidebar from './sidebar'
import SidebarTenant from './sidebar-tenant'
import MenuAside from './menu-aside'
import MenuAsideTenant from './menu-aside-tenant'
import OverlayMenu from './overlay-menu'
import SidebarProfessional from './professional/sidebar'
import SidebarEmployee from './employee/sidebar'
import QuickMenuMobile from './quickMenuMobile'
import QuickMenuMobilePatient from './quickMenuMobilePatient'
import { routeIsProfessional, routeStartsWith } from '@/helpers/routes'
import SPAVERSION from '@/plugins/http/version'
import { mapGetters } from 'vuex'
import bus from '@/utils/eventBus'
import { isMobile } from 'mobile-device-detect'

const tplBody = document.getElementsByTagName('body')[0]

export default {
  name: 'app',
  data () {
    return {
      SPA_VERSION: SPAVERSION,
      toShow: false,
      showOverLay: false,
      showBackdrop: false,
      ed: null
    }
  },
  methods: {
    hidenModal () {
      this.toShow = false
    },
    onMessage (message) {
      this.$message({
        message,
        type: 'success',
        duration: 3000
      })
    }
  },
  mounted () {
    bus.$on('to-show', values => {
      if (values.show) {
        this.toShow = true
      }
    })

    if (isMobile) {
      tplBody.classList.add('ls-closed')
    } else {
      tplBody.classList.remove('ls-closed')
    }

    bus.$on('open-menu-mobile', values => {
      this.showOverLay = values.show
    })
  },
  computed: {
    ...mapGetters(['userIsTenant', 'userIsPatient', 'userIsProfessional', 'userIsCompany', 'isLogged']),
    routeIsResetPassword () {
      return routeStartsWith(this.$route, 'auth.password.reset')
    },
    pageFull () {
      return get(this.$route.meta, 'full', false)
    },
    routeIsProfessional () {
      return routeIsProfessional(this.$route)
    },
    routeIsEmployee () {
      return routeStartsWith(this.$route, 'employee.')
    },
    routeIsPatient () {
      return routeStartsWith(this.$route, 'patient.')
    }
  },
  components: {
    RootHeader,
    Sidebar,
    MenuAside,
    OverlayMenu,
    SidebarProfessional,
    QuickMenuMobile,
    QuickMenuMobilePatient,
    SidebarEmployee,
    MenuAsideTenant,
    SidebarTenant
  }
}
</script>

<template lang="pug">
  div
    div
      router-view(v-if='pageFull')
    div(v-if='!pageFull')
      overlay-menu(v-if="isLogged")
      .overlay(style="display: block;", v-if="showOverLay")
      sidebar(v-if="isLogged && !userIsTenant")
      sidebar-tenant(v-if="isLogged && userIsTenant")
      //- Se estiver logado e nao for inquilino
      menu-aside(v-if="isLogged && !userIsTenant")
      menu-aside-tenant(v-if="isLogged && userIsTenant")
      router-view
</template>



// WEBPACK FOOTER //
// src/layout/app.vue